<template>
  <v-calendar v-bind:min-date="this.attributes[0].dates"
              v-bind:masks="masks"
              v-bind:attributes="attributes"
              disable-page-swipe is-expanded
              class="custom-calendar"
  >
    <template v-slot:day-content="{ day, attributes }">
      <span v-for="attr in attributes"
            v-bind:key="attr.key"
            class="h-full flex items-center justify-center font-primary font-semibold text-[21px] text-white bg-mtg-dark-cyan p-[5px] rounded-[5px]"
      >
        {{ day.day }}
      </span>
    </template>
  </v-calendar>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'PackageCalendar',
  data () {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: _.map(window.package_post_script_data.attributes, attribute => {
        return {
          key: attribute.key,
          dates: moment(attribute.dates, 'DD/MM/YYYY').toDate(),
        };
      }),
    };
  },
};
</script>
<style lang="scss">
.vc-container {
  &.custom-calendar {
    @apply w-full;
    .vc-pane-container {
      .vc-pane-layout {
        .vc-pane {
          .vc-weeks {
            .vc-day {
              @apply min-h-[100px] m-[5px];
            }
          }
        }
      }
    }
  }
}
</style>
